import { render, staticRenderFns } from "./team-finance-expenses.vue?vue&type=template&id=9796461e&"
import script from "./team-finance-expenses.ts?vue&type=script&lang=js&"
export * from "./team-finance-expenses.ts?vue&type=script&lang=js&"
import style0 from "./team-finance-expenses.vue?vue&type=style&index=0&id=9796461e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports